import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ServiceRequestAction, ServiceRequestService} from '../../../services/service-request.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, ServiceRequest} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {Router} from '@angular/router';
import {ResidentService} from '../../../services/resident.service';
import {environment} from 'environments/environment';
import {AuthTokenService} from '../../../services/auth-token.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'service-request-modal',
    templateUrl: './service-request-modal.component.html',
    styleUrls: ['./service-request-modal.component.scss']
})
export class ServiceRequestModalComponent implements OnInit {
    action = ServiceRequestAction;
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: ServiceRequest = new ServiceRequest();
    disabledSubmit = false;
    disabledFileInput = false;
    requestPriorities: Array<any> = [
        {name: 'urgent', displayName: 'Urgent'},
        {name: 'high', displayName: 'High'},
        {name: 'medium', displayName: 'Medium'},
        {name: 'low', displayName: 'Low'}];
    requestTypes: Array<any> = [];
    attachments: Array<any> = [];
    buildingSelectIsDisabled = false;
    step = 'buildingInfo';

    constructor(
        public api: ApiClientService,
        public serviceRequestService: ServiceRequestService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        private http: Http,
        private router: Router,
        private residentService: ResidentService,
        private authTokenService: AuthTokenService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if (this.serviceRequestService.serviceRequestInServiceRequestModal) {
            this.data = JSON.parse(JSON.stringify(this.serviceRequestService.serviceRequestInServiceRequestModal));
            this.getSuites(this.data.buildingId, this.data.suiteId);
            this.getRequestTypes(this.data.buildingId);
        } else {
            if(this.authService.userIsResident) {
                const residentSelectedBuilding = this.residentService.selectedBuilding;

                this.data.suiteId = residentSelectedBuilding.suite_id;
                this.data.buildingId = residentSelectedBuilding.buildingId;
                this.data.residentId = residentSelectedBuilding.residentBdId;

                this.getSuites(this.data.buildingId, this.data.suiteId);
                this.getRequestTypes(this.data.buildingId);
            } else {
                const b = this.urlService.queryParams['building'];
                if (b) {
                    this.data.buildingId = b;
                    this.getSuites(this.data.buildingId);
                    this.getRequestTypes(this.data.buildingId);
                }

                if (this.serviceRequestService.buildingsForUpdate.length === 1) {
                    this.data.buildingId = this.serviceRequestService.buildings[0].id;
                    this.getSuites(this.data.buildingId);
                    this.getRequestTypes(this.data.buildingId);
                }
            }
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.serviceRequestService.isServiceRequestModalShow = false;
                    this.serviceRequestService.serviceRequestInServiceRequestModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.serviceRequestService.isServiceRequestModalShow = false;
            this.serviceRequestService.serviceRequestInServiceRequestModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!this.authService.userIsResident) {
            if (!this.data.buildingId ) { toastr.warning('Building should not be blank.'); return; }
            if (!this.data.priority) { toastr.warning('Priority should not be blank.'); return; }
            if (!this.data.serviceRequestType) { toastr.warning('Type should not be blank.'); return; }
        }
        const building = this.serviceRequestService.buildings.find((item) => item.id == this.data.buildingId);
        const suite    = this.suites.find((item) => item.id == this.data.suiteId);
        const resident = this.residents.find((item) => item.id == this.data.residentId);
        const priority = this.data.priority;
        const serviceRequestType = this.data.serviceRequestType;

        if (!priority) { toastr.warning('Priority is not set.'); return; }
        if (!serviceRequestType) { toastr.warning('You didn\'t set request type'); return; }

        if (this.data.serviceRequestType === '0' && !this.data.serviceRequestTypeOther.trim()) {
            toastr.warning('Request Other Type field should not be blank');
            return;
        }

        if (this.data.serviceRequestTypeOther && !this.data.serviceRequestTypeOther.trim().length) {
            toastr.warning('Request Type should not be blank.');
            return;
        }
        let data: any = {
            building: {
                bdId:    (Number(this.residentService.selectedBuilding.buildingId)) || (this.data.buildingId),
                name:    this.residentService.selectedBuilding.buildingName || (building ? building.name : null),
                address: this.residentService.selectedBuilding.buildingAddress || (building ? building.address : null),
                timezone: this.residentService.selectedBuilding.buildingTimezone || (building && building.timeZone ? building.timeZone.value : null),
            },
            suite: {
                bdId:        (Number(this.residentService.selectedBuilding.suite_id)) || (suite ? this.data.suiteId : 0),
                suiteNumber: this.residentService.selectedBuilding.suiteNumber || (suite && suite.id ? suite.name : this.data.suiteNumber),
            },
            resident: {
                bdId:     (Number(this.residentService.selectedBuilding.residentBdId)) ||  (resident ? resident.id : 0),
                fullName: this.residentService.selectedBuilding.userName || (resident && resident.id ? resident.fullName : this.data.otherResident),
                email: this.residentService.selectedBuilding.userEmail || (resident && resident.id ? resident.email : null),
                phoneNumber: this.getResidentPhone(this.residentService.selectedBuilding.userPhones || resident)
            },
            description:             this.data.description,
            priority:                this.data.priority,
            notes:                   this.data.notes,
            permissionToEnter:       this.data.permissionToEnter,
            createdBy: {
                bdId: this.authService.user.id,
                fullName: this.authService.user.fullName,
                email: this.authService.user.email
            },
            isRead:                  0,
            status:                  'open',
            attachments:             this.attachments ? this.attachments : null,
        };
        if (this.data.serviceRequestType != '0')
            data.serviceRequestType = this.data.serviceRequestType;
        else if (this.data.serviceRequestTypeOther)
            data.serviceRequestTypeOther = this.data.serviceRequestTypeOther;

        this.disabledSubmit = true;

        this.api.post('domainServiceRequest', '/v1/service_request.json', data).subscribe(
            () => this.updateView('Service Request successfully created'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Create Service Request failed');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        if(this.router.url !== '/home') {
            this.serviceRequestService.getData();
         }
        this.form.reset();
        this.hideModal();
    }

    changeBuilding(buildingId: string) {
        this.form.controls['suiteId'].reset();
        this.form.controls['residentId'].reset();
        this.getSuites(+buildingId);
        this.getRequestTypes(buildingId);
    }

    changeUnit(suiteId: string) {
        this.form.controls['residentId'].reset();
        this.getResidents(+suiteId);
        if (suiteId + '' === '0') {
            this.form.controls['residentId'].setValue(0);
            this.data.residentId = 0;
            this.data.suiteNumber = '';
            this.data.residentFullName = '';
            this.residents.push(new ResidentForSelect(0, 'Other'));
        }
    }

    changeResident(residentId: string) {
        if (residentId === '0') this.data.residentFullName = '';
    }

    getSuites(buildingId: number, suiteId?: number): void {
        if (!buildingId) return;
        this.suites = [];
        this.residents = [];
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId);
                else this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.buildingSelectIsDisabled = false
        );
    }

    getResidents(suiteId: number): void {
        this.residents = [];
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                if(this.form.value.suiteId !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    residents.forEach(item => {
                        const resident = new ResidentForSelect(item.id, item.fullName, [], item.email);
                        (<any>resident).phones = item.phones;
                        this.residents.push(resident);
                    });
                    this.residents.push(new ResidentForSelect(0, 'Other'));
                }

            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd   = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 10000000) {
            toastr.warning('Maximum attachment size is 10MB.');
            return;
        }
        if (this.attachments.length >= 20 ) {
            toastr.warning('You can upload only up to 20 images.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token   = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.serviceRequestService.modalSpinnerShow = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainServiceRequest}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) { toastr.warning('Attachment path should not be blank.'); return; }
                const attachment = {name: file.name, path: res.path};
                this.attachments.push(attachment);
                this.serviceRequestService.modalSpinnerShow    = false;
                this.disabledFileInput = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.serviceRequestService.modalSpinnerShow    = false;
                this.disabledFileInput = false;
            }
        );
    }

    getRequestTypes(buildingId): void {
        this.requestTypes = [];
        const url = `/v1/settings/buildings/${buildingId}`;
        this.api.get('domainServiceRequest', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                const types = (body.setting && body.setting.serviceRequestTypes) || [];
                this.requestTypes = types.map(type => ({id: type.id, name: type.name}));
                this.requestTypes.push({id: 0, name: 'Other'});
            },
            error => this.api.errorHandler(error, 'Failed get types')
        );
    }

    removeFile(i: number) {
        swal(
            ConstantsService.getSwalConfig('Delete Attachment'),
            () => this.attachments.splice(i, 1)
        );
    }

    moveToTheNextStep(moveTo): void {
        if(this.step == 'buildingInfo') {
            if ((this.data.buildingId || this.residentService.selectedBuilding.buildingId) &&
                ((+this.data.suiteId || this.data.suiteNumber) || this.residentService.selectedBuilding.suite_id || this.residentService.selectedBuilding.suiteNumber) &&
                ((+this.data.residentId || this.data.otherResident) || this.residentService.selectedBuilding.residentBdId || this.residentService.selectedBuilding.userName))
                this.step = moveTo;
        } else if(this.step == 'generalInfo') {
            if (moveTo == 'notes' || moveTo == 'summary') {
                if(this.data.priority && this.data.serviceRequestType)
                    this.step = moveTo;
            } else
                this.step = moveTo;
        } else
            this.step = moveTo;
    }

    calculateCurrentProgressBarLength() {
        if(this.step == 'buildingInfo')
            return '13%';
        else if(this.step == 'generalInfo')
            return '39%';
        else if(this.step == 'notes')
            return '63%';
        else if(this.step == 'summary')
            return '88%';
    }

    getRequestTypeName() {
        let type = '';
        if(this.data.serviceRequestType && this.data.serviceRequestType != '0') {
            type = this.requestTypes.find(t => t.id == this.data.serviceRequestType);
            type = type ? (<any>type).name : '';
        } else
            type = this.data.serviceRequestType === '0' ? this.data.serviceRequestTypeOther : '';
        return type;
    }

    getRequestPriorityName() {
        return this.data.priority ? this.requestPriorities.find(t => t.name == this.data.priority).displayName : '';
    }

    getBuildingNameById() {
        const building = this.serviceRequestService.buildings.find((item) => item.id == this.data.buildingId);
        return building ? building.name : '';
    }

    getSuiteNameById() {
        let suite = '';
        if(this.data.suiteId)
            suite = this.suites.find((item) => item.id == this.data.suiteId).name;
        else if(this.data.suiteId === 0)
            suite = this.data.suiteNumber;
        return suite ? suite : '';
    }

    getResidentNameById() {
        let resident = '';
        if(this.data.residentId)
            resident = this.residents.find((item) => item.id == this.data.residentId).fullName;
        else if(this.data.residentId === 0)
            resident = this.data.otherResident;
        return resident ? resident : '';
    }

    getResidentPhone(resident) {
        if(!resident.phones || resident.phones.length < 1)
            return '';
        let primaryPhone = resident.phones.filter(phone => phone.isPrimaryPhone)[0];
        if(!primaryPhone || primaryPhone.length === 0)
            primaryPhone = resident.phones[0];
        return primaryPhone.phone;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-request-modal/service-request-modal.component.ts